<template>
  <div class="logo">
    <img class="logo__src" src="@/assets/imgs/logo.svg" />
    <div v-if="text" class="logo__text">braingineers</div>
  </div>
</template>

<style scoped>
.logo {
  margin-bottom: 40px;
}
.logo__src {
  height: 80px;
  width: 80px;
}
.logo__text {
  margin-top: 10px;
  font-size: 24px;
}
</style>

<script>
export default {
  name: "logo",
  props: {
    text: Boolean,
  },
};
</script>
